import MyRadioGroup from './radioGroup';

MyRadioGroup.install = function(Vue){
  Vue.component('MyRadioGroup', MyRadioGroup);
};

export default MyRadioGroup;